/*
 * Barre de recompenses du panier — maquette « Panier Recompenses - Options » 4b.
 *
 * Le rendu est fait par snippets/cart-rewards.liquid : c'est la seule source de
 * verite (montants, devise du marche, traductions, pourcentages). Ce fichier ne
 * fait que deux choses :
 *
 *   sync()    rejoue les transitions CSS — le re-render serveur recree les
 *             elements, la transition ne partirait donc jamais — et fait "poper"
 *             le palier qui vient d'etre debloque.
 *
 *   refresh() rappelle le rendu serveur du bloc apres une mutation panier qui
 *             n'a pas re-rendu le drawer (ajout depuis une page produit, app
 *             tierce...). Branche sur le wrap fetch de layout/theme.liquid, il
 *             garantit que la progression suit le prix du panier quel que soit
 *             le chemin emprunte.
 */
(function () {
  var REFRESH_DEBOUNCE = 400;
  // Au-dela de ce delai depuis le dernier rendu serveur, le bloc est considere
  // perime et merite une relecture. En deca, le drawer vient de se re-rendre
  // tout seul : inutile de redemander la section.
  var FRESH_FOR = 900;
  var refreshTimer = null;
  var inFlight = false;
  var lastSyncAt = 0;
  var rewardGiftSyncing = false;
  var rewardGiftSyncPromise = null;
  var rewardMutationPromise = null;
  var checkoutPending = null;

  function block() {
    return document.querySelector('[data-cart-rewards]');
  }

  function sync() {
    var el = block();
    if (!el) {
      // Panier vide ou bloc desactive : on repart de zero au prochain affichage.
      window.cartRewardsState = null;
      return;
    }

    if (el.closest('cart-drawer.active')) window.eveCartImages.warm(el);
    var previous = window.cartRewardsState;
    var current = {
      pct: [],
      shipOk: el.dataset.shipOk === 'true',
      giftOk: el.dataset.giftOk === 'true'
    };

    // Ce qu'on rejoue : la largeur des remplissages, et la position du marqueur
    // de prix pour qu'il glisse avec la barre au lieu de sauter a l'arrivee.
    //
    // On ne rembobine QUE s'il y a un mouvement reel a jouer. Au premier
    // affichage il n'y a pas d'etat precedent : la largeur ecrite par le serveur
    // est deja la bonne et on n'y touche pas. La detruire pour la restaurer en
    // requestAnimationFrame laissait la barre vide des que la frame tardait
    // (onglet en arriere-plan, rendu differe, drawer encore masque).
    var moves = [];

    var fills = el.querySelectorAll('.cart-rewards__fill');
    fills.forEach(function (fill, index) {
      var to = fill.dataset.pct;
      current.pct.push(to);
      var from = previous && previous.pct[index] !== undefined ? previous.pct[index] : null;
      if (from !== null && from !== to) {
        moves.push({ el: fill, prop: 'width', from: from + '%', to: to + '%' });
      }
    });

    if (moves.length) {
      replay(moves, el);
    } else {
      // Aucun mouvement a jouer : on reaffirme quand meme la largeur cible.
      // Idempotent (aucun effet visible si tout va bien), mais repare le bloc si
      // quoi que ce soit a laisse une largeur incoherente — la barre ne peut plus
      // rester vide alors que le serveur a calcule le bon pourcentage.
      fills.forEach(function (fill) {
        var target = fill.dataset.pct + '%';
        if (fill.style.width !== target) fill.style.width = target;
      });
    }

    // Le choix vient de basculer vers la ligne (ou l'inverse) : la hauteur du bloc
    // change et les deux etats ne partagent aucun element, le re-render serveur
    // les ayant recrees. Un fondu court evite le saut sec.
    current.chosen = el.dataset.chosen === 'true';
    if (previous && previous.chosen !== undefined && previous.chosen !== current.chosen) {
      var swapped = el.querySelector('.cart-rewards__choice') || el.querySelector('.cart-rewards__gift');
      if (swapped) {
        swapped.classList.remove('cart-rewards__swap');
        void swapped.offsetWidth;
        swapped.classList.add('cart-rewards__swap');
      }
    }

    // Palier franchi depuis le dernier rendu -> pop sur le noeud correspondant.
    if (previous) {
      if (!previous.giftOk && current.giftOk) {
        pop(el.querySelector('.cart-rewards__gift'));   // la ligne cadeau se debloque
      }
    }

    window.cartRewardsState = current;
    lastSyncAt = Date.now();
    syncRewardGiftLine(el);
  }

  // Rembobine puis relance : la transition CSS ne partirait pas toute seule
  // puisque le re-render serveur recree les elements.
  function replay(moves, el) {
    moves.forEach(function (m) {
      m.el.style.transition = 'none';
      m.el.style[m.prop] = m.from;
    });

    // Force un reflow pour que les valeurs de depart soient prises en compte
    // avant que les transitions ne reprennent.
    void el.offsetWidth;

    var applied = false;
    var apply = function () {
      if (applied) return;
      applied = true;
      moves.forEach(function (m) {
        m.el.style.transition = '';
        m.el.style[m.prop] = m.to;
      });
    };

    requestAnimationFrame(apply);
    // Filet de securite : si la frame tarde, on pose quand meme la valeur cible.
    // Mieux vaut perdre l'animation que laisser la barre sur l'ancienne valeur.
    setTimeout(apply, 120);
  }

  function pop(seg) {
    if (!seg) return;
    seg.classList.remove('just-unlocked');
    void seg.offsetWidth;
    seg.classList.add('just-unlocked');
    setTimeout(function () {
      seg.classList.remove('just-unlocked');
    }, 700);
  }

  // Les routes /cart/*.js savent renvoyer une section deja rendue dans LA MEME
  // reponse (parametre `sections`). On evite ainsi le second aller-retour :
  // avant, un clic enchainait la mutation puis un GET de la section.
  // Ce qui distingue visuellement deux rendus du bloc. Si la signature est
  // identique, le remplacer ne changerait rien a l'ecran — mais provoquerait un
  // flash (elements recrees, images rechargees). On s'en abstient.
  function signature(el) {
    if (!el) return null;
    var t = el.querySelector('[data-gift-title]');
    return [el.dataset.chosen, el.dataset.shipOk, el.dataset.giftOk,
            el.dataset.rewardRemaining, el.dataset.rewardGiftKey, el.dataset.rewardGiftVariant,
            t ? t.textContent.trim() : '',
            el.querySelectorAll('.cart-rewards__choice-card').length].join('|');
  }

  function applySection(data) {
    var html = data && data.sections && data.sections['cart-drawer'];
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var fresh = doc.querySelector('[data-cart-rewards]');
    var current = block();
    if (fresh && current) {
      if (signature(fresh) !== signature(current)) { window.eveCartImages.replaceNode(current, fresh); sync(); }
    } else if (!fresh && current) {
      current.remove();
      sync();
    }

    // La valeur du cadeau entre dans le prix barre et les economies : le pied de
    // panier depend donc du choix, il faut le remettre a jour lui aussi.
    var totals = doc.querySelector('.cart-drawer__footer.sanscode');
    var curTotals = document.querySelector('.cart-drawer__footer.sanscode');
    if (totals && curTotals) {
      curTotals.innerHTML = totals.innerHTML;   // innerHTML : on garde les classes que le JS de l'app bascule
    }

    // Le bloc « aveccode » est pilote par l'app de reduction : on ne touche qu'a
    // ses donnees, jamais a son contenu.
    var avec = doc.querySelector('.cart-drawer__footer.aveccode');
    var curAvec = document.querySelector('.cart-drawer__footer.aveccode');
    if (avec && curAvec) {
      ['data-originprice', 'data-originprice-money'].forEach(function (a) {
        if (avec.hasAttribute(a)) curAvec.setAttribute(a, avec.getAttribute(a));
      });
    }

    var banner = doc.querySelector('.cart-savings-banner');
    var curBanner = document.querySelector('.cart-savings-banner');
    if (banner && curBanner) { curBanner.replaceWith(banner); }
    else if (banner && !curBanner) {
      var ctas = document.querySelector('.cart__ctas');
      var checkout = document.getElementById('CartDrawer-Checkout');
      if (ctas && checkout) ctas.insertBefore(banner, checkout);
    } else if (!banner && curBanner) { curBanner.remove(); }

    clearTimeout(refreshTimer);          // le wrap fetch de theme.liquid en avait programme un
    return true;
  }

  function cartPost(route, payload, automaticGift) {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var host = document.getElementById(id);
      if (host && host.dataset.id && sections.indexOf(host.dataset.id) === -1) sections.push(host.dataset.id);
    });
    payload.sections = sections.join(',');
    payload.sections_url = window.location.pathname;
    function send() {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 15000);
      return fetch(window.Shopify.routes.root + route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal
      }).then(function (r) {
        if (!r.ok) throw new Error(route + ' a repondu ' + r.status);
        return r.json();
      }).finally(function () { clearTimeout(timeout); });
    }
    // The automatic remove/add pair owns one gift promise. Its second request
    // must not wait for actions that are themselves queued behind that promise.
    if (automaticGift) return send();
    var previousReward = rewardMutationPromise;
    var userMutation = window.cartMutationPromise;
    var activeGift = rewardGiftSyncPromise;
    var request = Promise.all([
      previousReward ? previousReward.catch(function () {}) : null,
      userMutation ? userMutation.catch(function () {}) : null,
      activeGift ? activeGift.catch(function () {}) : null
    ]).then(send);
    var tracked = request.finally(function () {
      if (rewardMutationPromise === tracked) rewardMutationPromise = null;
    });
    rewardMutationPromise = tracked;
    return tracked;
  }

  // Re-rend le drawer entier apres l'ajout/retrait du cadeau : au contraire
  // d'un simple choix, une vraie ligne panier doit apparaitre immediatement.
  function renderCartDrawer(data) {
    var html = data && data.sections && data.sections['cart-drawer'];
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var current = document.querySelector('#CartDrawer');
    if (!fresh || !current) return false;
    window.eveCartImages.replace(current, fresh.innerHTML);
    var drawer = document.querySelector('cart-drawer');
    var freshDrawer = doc.querySelector('cart-drawer');
    if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    var overlay = current.querySelector('#CartDrawer-Overlay');
    if (drawer && overlay) overlay.addEventListener('click', function () { drawer.close(); });
    var bubbleHtml = data.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      var bubbleContent = bubbleDoc.querySelector('.shopify-section');
      if (bubbleContent) {
        ['cart-icon-bubble', 'cart-icon-bubble2'].forEach(function (id) {
          var bubble = document.getElementById(id);
          if (bubble) bubble.innerHTML = bubbleContent.innerHTML;
        });
      }
    }
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var host = document.getElementById(id);
      if (!host) return;
      var html = data.sections[host.dataset.id];
      if (!html) return;
      var content = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
      var currentContent = host.querySelector('.js-contents');
      if (content && currentContent) window.eveCartImages.replace(currentContent, content.innerHTML);
    });
    if (freshDrawer) {
      document.querySelectorAll('cart-items, #main-cart-footer').forEach(function (element) {
        element.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      });
    }
    if (drawer && typeof drawer.refreshFocus === 'function') drawer.refreshFocus();
    sync();
    return true;
  }

  // La remise « POCHETTE » est une remise automatique Shopify. Le theme n'agit
  // que sur la ligne produit : Shopify calcule ensuite le prix a 0 €.
  function syncRewardGiftLine(el) {
    if (rewardGiftSyncing) return rewardGiftSyncPromise;
    // Quantity changes re-render the current gift state before calling sync again.
    // Do not capture a stale gift decision while that mutation is still running.
    if (window.cartMutationPromise) return null;
    if (rewardMutationPromise) return rewardMutationPromise;
    if (!el) return null;
    var wantedVariant = el.dataset.rewardGiftVariant || '';
    var currentKey = el.dataset.rewardGiftKey || '';
    var currentVariant = el.dataset.rewardGiftVariantId || '';
    var eligible = el.dataset.giftOk === 'true';
    var shouldHaveGift = eligible && !!wantedVariant;
    var action = null;

    if (currentKey && (!shouldHaveGift || currentVariant !== wantedVariant)) {
      action = cartPost('cart/update.js', { updates: (function () { var updates = {}; updates[currentKey] = 0; return updates; })() }, true);
      if (shouldHaveGift) {
        action = action.then(function () {
          return cartPost('cart/add.js', {
            items: [{ id: wantedVariant, quantity: 1, properties: { _cart_reward_gift: 'POCHETTE' } }]
          }, true);
        });
      }
    } else if (!currentKey && shouldHaveGift) {
      action = cartPost('cart/add.js', {
        items: [{ id: wantedVariant, quantity: 1, properties: { _cart_reward_gift: 'POCHETTE' } }]
      }, true);
    }

    if (!action) return null;
    rewardGiftSyncing = true;
    rewardGiftSyncPromise = action
      .then(function (data) {
        if (!renderCartDrawer(data)) {
          if (!applySection(data)) refresh();
        }
        return true;
      })
      .catch(function () {
        refresh();
        return false;
      })
      .then(function (success) {
        rewardGiftSyncing = false;
        rewardGiftSyncPromise = null;
        return success;
      });
    return rewardGiftSyncPromise;
  }

  // Settle the quantity change first, then reconcile the gift from its fresh markup.
  function settleBeforeCheckout() {
    var mutation = window.cartMutationPromise;
    if (mutation) {
      return mutation.then(function (state) {
        if (!state) return false;
        return settleBeforeCheckout();
      });
    }
    var pending = rewardGiftSyncPromise || rewardMutationPromise;
    if (pending) {
      return pending.then(function (success) {
        if (success === false) return false;
        return settleBeforeCheckout();
      });
    }
    var gift = syncRewardGiftLine(block());
    return gift ? gift.then(function (success) { return success !== false; }) : Promise.resolve(true);
  }

  // Checkout must include the last quantity change and its resulting gift state.
  function guardCheckout(event, checkout, implicitSubmit) {
    if (!checkout) return;
    var el = block();
    var giftMissing = el && el.dataset.giftOk === 'true' && el.dataset.rewardGiftVariant && !el.dataset.rewardGiftKey;
    if (!window.cartMutationPromise && !rewardGiftSyncPromise && !rewardMutationPromise && !giftMissing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkout.disabled = true;
    checkout.setAttribute('aria-busy', 'true');
    checkoutPending = settleBeforeCheckout().catch(function () { return false; }).then(function (success) {
      checkoutPending = null;
      var freshCheckout = document.getElementById(checkout.id);
      checkout.removeAttribute('aria-busy');
      checkout.disabled = false;
      if (freshCheckout) freshCheckout.removeAttribute('aria-busy');
      if (success && freshCheckout && !freshCheckout.disabled && freshCheckout.form) {
        if (implicitSubmit) freshCheckout.form.requestSubmit();
        else freshCheckout.form.requestSubmit(freshCheckout);
      }
    });
  }
  document.addEventListener('click', function (event) {
    var checkout = event.target && event.target.closest && event.target.closest('#CartDrawer-Checkout, #checkout');
    guardCheckout(event, checkout, false);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || (form.id !== 'CartDrawer-Form' && form.id !== 'cart')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    var checkout = document.getElementById(form.id === 'cart' ? 'checkout' : 'CartDrawer-Checkout');
    guardCheckout(event, checkout, !event.submitter);
  }, true);

  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (inFlight) return;
      // Rien a rafraichir si le drawer n'est pas monte (pas de panier sur la page).
      if (!document.querySelector('cart-drawer')) return;
      // Le drawer vient de se re-rendre : le bloc porte deja le bon prix.
      if (Date.now() - lastSyncAt < FRESH_FOR) return;
      if (window.cartMutationPromise || rewardGiftSyncPromise || rewardMutationPromise) return;
      var requestedAtSync = lastSyncAt;
      inFlight = true;
      fetch(window.Shopify.routes.root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (lastSyncAt !== requestedAtSync || window.cartMutationPromise || rewardGiftSyncPromise || rewardMutationPromise) return;
          var html = sections && sections['cart-drawer'];
          if (!html) return;
          var fresh = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-cart-rewards]');
          var current = block();
          if (fresh && current) {
            window.eveCartImages.replaceNode(current, fresh);
          } else if (fresh && !current) {
            // Le bloc n'existait pas (panier vide au chargement) : on l'insere
            // a sa place dans le drawer.
            var host = document.querySelector('cart-drawer .reco');
            if (host) host.appendChild(fresh);
          } else if (!fresh && current) {
            current.remove();
          }
          sync();
        })
        .catch(function () { /* le prochain rendu du drawer remettra le bloc a jour */ })
        .then(function () { inFlight = false; });
    }, REFRESH_DEBOUNCE);
  }

  // Popup de detail du cadeau. Delegue sur document, comme les autres handlers :
  // le markup du bloc est reinjecte a chaque re-render de section.
  // Le popup est deplace dans <body> a l'ouverture. Rendu dans le tiroir, son
  // position:fixed se cale sur le tiroir (400px) et non sur la fenetre : le
  // voile ne couvrait pas la page, et un clic a gauche filait jusqu'a l'overlay
  // du panier, qui fermait tout. Au niveau de <body> le voile prend la fenetre.
  var portalHome = null;
  var carouselDrag = null;

  function openGiftDetail(modal, trigger) {
    portalHome = trigger && trigger.parentNode ? trigger.parentNode : modal.parentNode;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.hidden = false;
    var x = modal.querySelector('.cart-rewards__modal-x');
    if (x && x.focus) x.focus();
  }

  function closeGiftDetail() {
    var open = document.querySelector('[data-cart-rewards-modal]:not([hidden])');
    if (!open) return false;
    open.hidden = true;
    // Retour a sa place, sauf si le bloc a ete re-rendu entre-temps : le nouveau
    // markup porte deja son propre popup, celui-ci n'est plus qu'un orphelin.
    if (portalHome && portalHome.isConnected) {
      portalHome.appendChild(open);
      var trigger = portalHome.querySelector('[data-cart-rewards-open]');
      if (trigger && trigger.focus) trigger.focus();
    } else if (open.parentNode === document.body) {
      open.parentNode.removeChild(open);
    }
    if (carouselDrag) carouselDrag.carousel.classList.remove('is-dragging');
    portalHome = null;
    carouselDrag = null;
    return true;
  }

  function setCarouselSlide(carousel, nextIndex) {
    if (!carousel) return;
    var slides = carousel.querySelectorAll('.cart-rewards__modal-slide');
    if (slides.length < 2) return;
    var index = Number(nextIndex);
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    var track = carousel.querySelector('[data-cart-rewards-track]');
    if (track) track.style.transform = 'translateX(-' + (index * 100) + '%)';
    carousel.dataset.cartRewardsSlide = String(index);
    carousel.querySelectorAll('[data-cart-rewards-carousel-to]').forEach(function (dot, dotIndex) {
      var active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  // Glissement tactile et souris. On laisse le geste vertical au navigateur pour
  // que la fiche puisse toujours defiler, et on ne capte qu'un deplacement net
  // sur l'axe horizontal.
  document.addEventListener('pointerdown', function (event) {
    if (event.button !== undefined && event.button !== 0) return;
    if (event.target.closest && event.target.closest('button')) return;
    var viewport = event.target.closest && event.target.closest('.cart-rewards__modal-viewport');
    var carousel = viewport && viewport.closest('[data-cart-rewards-carousel]');
    if (!carousel || carousel.querySelectorAll('.cart-rewards__modal-slide').length < 2) return;
    carouselDrag = {
      carousel: carousel,
      viewport: viewport,
      pointerId: event.pointerId,
      startX: event.clientX,
      lastX: event.clientX,
      index: Number(carousel.dataset.cartRewardsSlide || 0),
      moved: false
    };
    if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
  });

  document.addEventListener('pointermove', function (event) {
    if (!carouselDrag || event.pointerId !== carouselDrag.pointerId) return;
    var delta = event.clientX - carouselDrag.startX;
    carouselDrag.lastX = event.clientX;
    if (Math.abs(delta) > 4) carouselDrag.moved = true;
    if (!carouselDrag.moved) return;
    var track = carouselDrag.carousel.querySelector('[data-cart-rewards-track]');
    if (!track) return;
    carouselDrag.carousel.classList.add('is-dragging');
    track.style.transform = 'translateX(calc(-' + (carouselDrag.index * 100) + '% + ' + delta + 'px))';
  });

  function finishCarouselDrag(event) {
    if (!carouselDrag || (event && event.pointerId !== carouselDrag.pointerId)) return;
    var drag = carouselDrag;
    carouselDrag = null;
    drag.carousel.classList.remove('is-dragging');
    var track = drag.carousel.querySelector('[data-cart-rewards-track]');
    if (track) void track.offsetWidth;
    var delta = drag.lastX - drag.startX;
    var threshold = Math.min(80, drag.viewport.clientWidth * 0.18);
    if (Math.abs(delta) >= threshold) setCarouselSlide(drag.carousel, drag.index + (delta < 0 ? 1 : -1));
    else setCarouselSlide(drag.carousel, drag.index);
  }

  document.addEventListener('pointerup', finishCarouselDrag);
  document.addEventListener('pointercancel', finishCarouselDrag);

  // Capture : on passe AVANT le handler de fermeture du tiroir. Tout clic hors
  // de la fiche ferme le popup, et seulement lui.
  document.addEventListener('click', function (event) {
    var modal = document.querySelector('[data-cart-rewards-modal]:not([hidden])');
    if (!modal) return;
    var panel = modal.querySelector('.cart-rewards__modal-panel');
    if (panel && panel.contains(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    closeGiftDetail();
  }, true);

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-cart-rewards-close]')) {
      event.preventDefault();
      closeGiftDetail();
      return;
    }

    var carouselControl = t.closest('[data-cart-rewards-carousel-prev], [data-cart-rewards-carousel-next], [data-cart-rewards-carousel-to]');
    if (carouselControl) {
      event.preventDefault();
      var carousel = carouselControl.closest('[data-cart-rewards-carousel]');
      var currentSlide = Number(carousel && carousel.dataset.cartRewardsSlide || 0);
      if (carouselControl.hasAttribute('data-cart-rewards-carousel-prev')) setCarouselSlide(carousel, currentSlide - 1);
      else if (carouselControl.hasAttribute('data-cart-rewards-carousel-next')) setCarouselSlide(carousel, currentSlide + 1);
      else setCarouselSlide(carousel, Number(carouselControl.dataset.cartRewardsCarouselTo));
      return;
    }

    var opener = t.closest('[data-cart-rewards-open]');
    if (!opener) return;
    // La ligne peut heberger un bouton : on ne lui vole pas son clic.
    var innerBtn = t.closest('button');
    if (innerBtn && opener.contains(innerBtn)) return;
    var block = opener.closest('[data-cart-rewards]');
    var modal = block && block.querySelector('[data-cart-rewards-modal]');
    if (!modal) return;
    event.preventDefault();
    openGiftDetail(modal, opener);
  });

  // Clavier : la ligne est un role="button", elle doit repondre a Entree/Espace.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { closeGiftDetail(); return; }
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      var modal = document.querySelector('[data-cart-rewards-modal]:not([hidden])');
      var carousel = modal && modal.querySelector('[data-cart-rewards-carousel]');
      if (carousel) {
        event.preventDefault();
        var currentSlide = Number(carousel.dataset.cartRewardsSlide || 0);
        setCarouselSlide(carousel, currentSlide + (event.key === 'ArrowLeft' ? -1 : 1));
      }
      return;
    }
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var opener = event.target && event.target.closest && event.target.closest('[data-cart-rewards-open]');
    if (!opener) return;
    event.preventDefault();
    opener.click();
  });

  // Choix du cadeau : on l'ecrit dans l'attribut de panier « Cadeau choisi ».
  // Il survit ainsi aux rechargements et remonte sur la commande, et le rendu
  // reste entierement serveur — aucun etat client a resynchroniser.
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest && event.target.closest('[data-cart-rewards-gift]');
    if (!el || el.dataset.busy) return;
    event.preventDefault();
    el.dataset.busy = '1';

    // BASCULE IMMEDIATE : les deux etats sont deja dans le DOM, on ne fait que
    // changer data-chosen. L'appel serveur part en parallele et ne sert qu'a
    // enregistrer le choix — plus aucune attente perceptible au clic.
    var b = block();
    var title = el.dataset.cartRewardsGift;
    if (b) {
      if (title) {
        var src = el.querySelector('img');
        var dest = b.querySelector('.cart-rewards__gift-media');
        var label = b.querySelector('[data-gift-title]');
        if (src && dest) {
          var img = dest.querySelector('img') || document.createElement('img');
          img.className = 'cart-rewards__gift-img';
          img.src = src.currentSrc || src.src;      // deja en cache : affichage instantane
          img.removeAttribute('srcset');
          img.alt = title;
          if (!img.parentNode) dest.appendChild(img);
        }
        if (label) label.textContent = title;
      }
      b.dataset.chosen = title ? 'true' : 'false';
      if (window.cartRewardsState) window.cartRewardsState.chosen = !!title;
    }
    el.classList.add('is-pending');

    cartPost('cart/update.js', { attributes: { 'Cadeau choisi': title } })
      .then(function (data) { if (!applySection(data)) refresh(); })
      .catch(function () {
        delete el.dataset.busy;
        el.classList.remove('is-pending');
        if (b) b.dataset.chosen = b.dataset.chosen === 'true' ? 'false' : 'true';
      });
  });

  // « Complete ton panier » : ajout direct depuis la barre. On delegue sur document
  // pour resister aux re-renders du drawer (le markup est reinjecte a chaque
  // changement de panier, un listener pose sur le bouton serait perdu).
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-cart-rewards-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var card = btn.closest('.cart-rewards__upsell-card');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    if (card) card.classList.add('is-pending');

    cartPost('cart/add.js', { items: [{ id: btn.dataset.cartRewardsAdd, quantity: 1 }] })
      .then(function (data) {
        if (card) card.classList.add('is-added');
        if (!renderCartDrawer(data) && !applySection(data)) refresh();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        if (card) card.classList.remove('is-pending');
      });
  });

  window.cartRewards = { sync: sync, refresh: refresh };
  window.cartRewardsWaitForGift = function () {
    var pending = [rewardGiftSyncPromise, rewardMutationPromise].filter(Boolean);
    return pending.length ? Promise.all(pending) : null;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
